import AvataUpload from "components/AvataUpload";
import { Form } from "antd";
import React from "react";
//import UploadImages from "components/UploadImages";
import UploadImagesUser from "components/UploadUser";

const SettingAvatar = () => {
  return (
    <>
      {" "}
      <Form.Item
        name="image"
      >
        <UploadImagesUser maximumUploadItems={1} />
      </Form.Item>
    </>
  );
};

export default SettingAvatar;
